import { render, staticRenderFns } from "./TaxationWithholding.vue?vue&type=template&id=e29e5090&scoped=true&"
import script from "./TaxationWithholding.vue?vue&type=script&lang=js&"
export * from "./TaxationWithholding.vue?vue&type=script&lang=js&"
import style0 from "./TaxationWithholding.vue?vue&type=style&index=0&id=e29e5090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29e5090",
  null
  
)

export default component.exports